// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-action-template/src/index.tsx

// TODO: Check if the icon is alined properly.
// If it is not: Replace/extend defaultAlignedActionIconGroupProps to make it look right.
// https://stash.int.klarna.net/projects/UI/repos/bubble-ui/pull-requests/121/overview?commentId=2244923
import baseIcon, { defaultAlignedActionIconGroupProps } from '@bubble-ui/temp-icon-base';
var ActionIconDealsPath = 'm10.968 0 .767 5.126c.057.388-.048.783-.293 1.09l-4.173 5.246a1.427 1.427 0 0 1-2 .231L.79 8.155A1.417 1.417 0 0 1 .56 6.16L4.726.92c.248-.31.613-.504 1.01-.532L10.967 0ZM9.237 2.16l.45 3.004L6.054 9.73 2.528 6.944l3.624-4.556 3.085-.229ZM7.288 5.454c.561 0 1.016-.453 1.016-1.012 0-.56-.455-1.013-1.016-1.013-.56 0-1.016.453-1.016 1.013 0 .559.455 1.012 1.016 1.012Z';
var ActionIconDeals = baseIcon('ActionIconDeals', {
  groupProps: defaultAlignedActionIconGroupProps,
  getPath: () => ActionIconDealsPath
});
export default ActionIconDeals;
//# sourceMappingURL=index.js.map